import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

/* Animation */
const slideIn = keyframes`
  from { opacity: 0; transform: translateX(24px); }
  to   { opacity: 1; transform: translateX(0); }
`;

/* Container */
export const Shell = styled.div`
    animation: ${slideIn} 260ms ease-out both;
`;

/* Form field wrapper */
export const Field = styled.div`
    display: grid;
    gap: 4px;
`;

/* Label */
export const Label = styled.label`
    font-size: 12px;
    color: #aab3c5;
`;

/* Base input */
export const Input = styled.input`
    appearance: none;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
    color: #e8ecf5;
    border-radius: 10px;
    padding: 12px 14px;
    outline: none;
    font-size: 14px;

    &:focus {
        border-color: #5e84ed;
        box-shadow: 0 0 0 3px rgba(94, 132, 237, 0.2);
    }
`;

/** Input with room for an eye toggle on the right */
export const InputWithToggle = styled(Input)<{ $hasToggle?: boolean }>`
    padding-right: ${({ $hasToggle }) => ($hasToggle ? "44px" : "14px")};
`;

export const InputWrap = styled.div`
    position: relative;
    width: 100%;
`;

export const EyeToggle = styled.button`
    all: unset;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    line-height: 0;
    color: #aab3c5;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    &:hover {
        color: #c7d0e6;
    }

    &:focus-visible {
        outline: 2px solid #5e84ed;
        outline-offset: 2px;
        border-radius: 6px;
    }
`;

/** Bottom action bar: Cancel (left) | Save (right) */
export const ActionBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between; /* left & right edges */
    gap: 12px;
    width: 100%;
    padding-top: 8px;
`;

export const Checklist = styled.ul`
    list-style: none;
    padding: 0;
    margin: 8px 0 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const CheckItem = styled.li<{ $ok: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    padding-top: 4px;
    padding-left: 17px;
    font-size: 12px;
    font-weight: ${({ $ok }) => ($ok ? 600 : 500)};
    color: ${({ $ok }) => ($ok ? "#5E84ED" : "#9AA7C7")};

    & > span.icon {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        color: #5e84ed;
    }
`;
